import { render, staticRenderFns } from "./confirm-reason-modal.vue?vue&type=template&id=ecb0519a&"
import script from "./confirm-reason-modal.vue?vue&type=script&lang=ts&"
export * from "./confirm-reason-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports